const formatter = new Intl.NumberFormat('hu-HU', {
  style: 'currency',
  currency: 'HUF',
  minimumFractionDigits: 0
});

export const formatPrice = (price: string | number = 0) =>
  formatter.format(parseFloat(price.toString()));
